export default "__VITE_ASSET__4gIu1M_e__"